// extracted by mini-css-extract-plugin
export default {"container":"DrawerNavigationMenuButton_container__BVx+s","isSelected":"DrawerNavigationMenuButton_isSelected__eqySr","arrowIcon":"DrawerNavigationMenuButton_arrowIcon__ZoFXp"};